import { render, staticRenderFns } from "./basic_experiment.vue?vue&type=template&id=1aba0ef0&scoped=true"
import script from "./basic_experiment.vue?vue&type=script&lang=js"
export * from "./basic_experiment.vue?vue&type=script&lang=js"
import style0 from "./basic_experiment.vue?vue&type=style&index=0&id=1aba0ef0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aba0ef0",
  null
  
)

export default component.exports